import * as React from "react";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

const base =
  "inline-flex items-center justify-center gap-2 rounded-[8px] font-semibold whitespace-nowrap select-none transition-all duration-200 ease-smooth focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-pink/70 disabled:opacity-50 disabled:pointer-events-none jea-ripple";

const variants = {
  "primary-pink":
    "bg-accent-pink text-[#091424] hover:bg-accent-pink-light active:bg-accent-pink-dark shadow-sm",
  "outline-pink":
    "border border-accent-pink text-accent-pink bg-transparent hover:bg-accent-pink/10",
  "outline-neutral":
    "border border-border-default text-white bg-transparent hover:bg-bg-tertiary",
  danger: "bg-danger text-white hover:opacity-90",
  ghost: "text-text-secondary hover:text-white hover:bg-bg-tertiary",
};

const sizes = {
  sm: "h-9 px-3 text-[13px]",
  md: "h-11 px-5 text-[14px]",
  lg: "h-12 px-6 text-[15px]",
};

const JeaButton = React.forwardRef(
  (
    {
      className,
      variant = "primary-pink",
      size = "md",
      loading = false,
      fullWidth = false,
      children,
      type = "button",
      ...props
    },
    ref
  ) => {
    return (
      <motion.button
        ref={ref}
        type={type}
        whileTap={{ scale: 0.98 }}
        whileHover={{ scale: props.disabled || loading ? 1 : 1.01 }}
        transition={{ duration: 0.12 }}
        className={cn(
          base,
          variants[variant] || variants["primary-pink"],
          sizes[size] || sizes.md,
          fullWidth && "w-full",
          className
        )}
        disabled={loading || props.disabled}
        {...props}
      >
        {loading ? (
          <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
        ) : (
          children
        )}
      </motion.button>
    );
  }
);
JeaButton.displayName = "JeaButton";

export { JeaButton };
export default JeaButton;
